<template>
  <div class="max-w-4xl mx-auto p-6 bg-white rounded-xl shadow">
    <h1 class="text-3xl font-bold text-gray-900 mb-6">Instructions for Authors</h1>

    <section class="prose max-w-none">
      <h2><strong>Authorship Criteria</strong></h2>
      <p>
        All listed authors must have made a substantial contribution to the conception, design, execution, or interpretation of the study. 
        Individuals who do not meet authorship criteria should be acknowledged rather than listed as authors. 
        The corresponding author is responsible for ensuring that all co-authors have reviewed and approved the final manuscript.
      </p>

      <h2><strong>Plagiarism and Originality Requirements</strong></h2>
      <p>
        Manuscripts must be original and must not have been published or submitted elsewhere. 
        Authors are required to ensure that their work is free from plagiarism, including self-plagiarism. 
        The journal reserves the right to use plagiarism detection software at any stage of review or publication.
      </p>

      <h2><strong>Research Ethics</strong></h2>
      <p>
        Studies involving human participants, Indigenous Peoples (IP) groups, or animals must adhere to internationally accepted ethical standards and comply with applicable national regulations.
      </p>

      <h3>Human Participants</h3>
      <p>
        Authors must submit certification and state that approval was obtained from an Institutional Review Board (IRB) or equivalent ethics committee, 
        and that informed consent was secured from participants.
      </p>

      <h3>Indigenous Peoples (IP) Group</h3>
      <p>
        Research involving IP communities must have prior clearance from the National Commission on Indigenous Peoples (NCIP) or other Level II accredited IRB 
        and should demonstrate respect for cultural protocols and rights.
      </p>

      <h3>Animal Studies</h3>
      <p>
        Research involving animals must comply with the ethical guidelines of the Institutional Care and Use Committee (IACUC) or equivalent oversight body.
      </p>

      <h2><strong>Conflict of Interest</strong></h2>
      <p>
        All authors must disclose any financial or personal relationships that may influence their work. 
        A conflict-of-interest statement must be included in the manuscript even if no conflict exists 
        (e.g., “The authors declare no conflict of interest.”).
      </p>

      <h2><strong>Data Sharing and Transparency</strong></h2>
      <p>
        Authors are encouraged to make their data available to support reproducibility and transparency. 
        Where appropriate, a data availability statement should be included, indicating how readers can access the underlying data, software, or materials used in the study.
      </p>
    </section>
  </div>
</template>

<script setup>

</script>

<style scoped>
.prose h2 { font-size: 1.5rem; margin-top: 1.25rem; margin-bottom: 0.5rem; }
.prose h3 { font-size: 1.25rem; margin-top: 1rem; margin-bottom: 0.5rem; }
.prose ul { list-style: disc; padding-left: 1.25rem; }
</style>
